import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Alert, Spin, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import { gapi } from 'gapi-script';
import googleDrive from '../../Actions/googleDrive';
import  CONFIG  from '../../Helpers/GoogleDriveConfig';
import  { getEnvironment }  from '../../helpers';
const { saveGoogleData, getGoogleData, selectTab, revokeGoogleAccess } = googleDrive.actions;
const environment = getEnvironment();
const GOOGLE_DRIVE_CONFIG = CONFIG[environment];
const { DISCOVERY_DOCS, SCOPE, API_KEY, CLIENT_ID } = GOOGLE_DRIVE_CONFIG;

class GoogleDrive extends Component {
	constructor(props) { 
        super(props);
		this.connectGoogleDrive = this.connectGoogleDrive.bind(this);
		this.revokeDriveAccess = this.revokeDriveAccess.bind(this);
	}
	
	componentDidMount() {
		this.props.getGoogleData();
	}    

  	render() {  
		const { isLoading, isFreePlan } = this.props;
		const { name, email, image } = this.props.drive;
    	return (			
      		<Fragment>
                <div className="download-xmls-container-text" style={{marginBottom: "10px"}}>
					Esta opción te permite habilitar que las descargas de tus archivos XML o PDF se almacenen directamente en una carpeta de Google Drive, ya sea de tus solicitudes de descarga programadas o manuales.
		        </div> 
				<Alert
					message={ 
						<div> 
							Recuerda configurar la <Link to="/settings"  onClick={this.goToSettingsTab.bind(this,'3')}> organización de carpetas </Link> y <Link to="/settings"  onClick={this.goToSettingsTab.bind(this,'2')}>nombres de archivos</Link>.
							 Si realizas cambios posteriores a la descarga se creará una nueva carpeta con la nueva configuración.
							
						</div>
					}
					type="warning"
					closable
					showIcon
				/>
				<div className="box-container">
					<h1 className="box-title text-center">Conectado a la cuenta:</h1>
					<div className="box-middle">
						{
							email !== '' ?
							<div className="account-container">
								<figure className="image">
									<img src={image} alt="" className="img-responsive image-rounded"/>
								</figure>
								<div className="info">
									<span className="light-text">{name}</span>
									<span className="small-text">{email}</span> 
								</div>
							</div>
							:
							<span className="label">Conéctate a una cuenta de Google Drive</span>
						}
					</div>
					{ email === '' ?
						<Button disabled={isFreePlan}  onClick={this.connectGoogleDrive}  type="primary" >Conectar</Button> 
						:
						<Popconfirm
							title="¿Está seguro que desea desvincular su cuenta de Google Drive?. Esto significa que se detendrá  la copia tus archivos, sin embargo podrá volver a vincular su cuenta"
							onConfirm={this.revokeDriveAccess}
							okText="Si"
							cancelText="No"
                    	>
							<Button type="primary" >Desvincular</Button>
						</Popconfirm>
					}
				</div>
				<div className="drive-path">
						<span className="label">Nombre de la carpeta en Google Drive:</span>
						<Input								
							value="SW efisco"
							disabled
						/>
					</div>
					{ isLoading &&
					<div className="loading-container">
						<Spin size="large" tip="Cargando" />
                    </div>    
                }
                
            </Fragment>
    	);
    }

    connectGoogleDrive() {
        gapi.load('client:auth2', this.initClient);       
	}

	revokeDriveAccess(){
		this.props.revokeGoogleAccess();
	}

	goToSettingsTab (tab) {
		this.props.selectTab(tab);
	}

	initClient = async () => {
		try {
			const authResult = await new Promise((resolve, reject) => {
				gapi.auth2.authorize({
					client_id: CLIENT_ID,
					scope: SCOPE,
					response_type: 'code',
					prompt: 'consent',
				}, (response) => {
					if (response.error) {
						reject(response.error);
					} else {
						resolve(response);
					}
				});
			});

			let auth2 = gapi.auth2.getAuthInstance();

			if (!auth2) {
				await gapi.auth2.init({
					client_id: CLIENT_ID,
					scope: SCOPE
				});
				auth2 = gapi.auth2.getAuthInstance();
			}
			
			let user;
			
			if (!auth2.isSignedIn.get()) {
				user = await auth2.signIn();
			} else {
				user = auth2.currentUser.get();
			}
			
			this.props.saveGoogleData({
				name: user.getBasicProfile().getName(),
				email: user.getBasicProfile().getEmail(),
				image: user.getBasicProfile().getImageUrl(),
				code: authResult.code
			});

		} catch (error) {
			console.error('Error during Google auth initialization:', error);
		}
	};
}

const mapStateToProps = state => {	
	return {
		isLoading:state._genericComponents.loading.find('googleDriveLoading'),
		drive: state.googleDrive.data,
		isFreePlan: state.license.isFreePlan
	};
};

const mapDispatchToProps = dispatch => {
    return {
		saveGoogleData:(data) => {
			dispatch(saveGoogleData(data));
		},
		getGoogleData:() => {
			dispatch(getGoogleData());
		},
		selectTab(tab) {			
            dispatch(selectTab(tab))
        },
		revokeGoogleAccess() {
			dispatch(revokeGoogleAccess());
		}
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(GoogleDrive);
